import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=3ea8005c&scoped=true&"
import script from "./select-box.vue?vue&type=script&lang=js&"
export * from "./select-box.vue?vue&type=script&lang=js&"
import style0 from "./select-box.vue?vue&type=style&index=0&id=3ea8005c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8005c",
  null
  
)

export default component.exports